// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type BrokersBrokerAttentionNeededItem } from 'utils/web_api.schemas'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type CreateOrEditNAVItemParams = {
  status: string
  reason: string
  enrollment_ids: string[]
  broker_ids: string[]
  tag_ids: string[]
  notes: string
}

export function useCreateOrEditNAVItem ({ id }: { id?: string }) {
  const isCreate = !id
  return useMutation<BrokersBrokerAttentionNeededItem, GrapeAPIErrorType, CreateOrEditNAVItemParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        isCreate ? 'post' : 'patch',
        isCreate
          ? '/api/web/brokers/broker_attention_needed_items'
          : `/api/web/brokers/broker_attention_needed_items/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
